"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageUtil = void 0;
var ColorHash = require('color-hash');
var ImageUtil = /** @class */ (function () {
    function ImageUtil() {
    }
    ImageUtil.makeInitialImage = function (name) {
        var canvas = document.createElement('canvas');
        canvas.style.display = 'none';
        canvas.width = 32;
        canvas.height = 32;
        document.body.appendChild(canvas);
        var context = canvas.getContext('2d');
        if (context) {
            var colorHash = new ColorHash();
            var colorNum = colorHash.hex(name);
            context.fillStyle = colorNum;
            context.fillRect(0, 0, canvas.width, canvas.height);
            context.font = "16px Arial";
            context.fillStyle = "#fff";
            var split = name.split(' ');
            var len = split.length;
            var first = split[0][0];
            if (len > 1) {
                var last = split[len - 1][0];
                var initials = first + last;
                context.fillText(initials.toUpperCase(), 3, 23);
            }
            else {
                context.fillText(first.toUpperCase(), 10, 23);
            }
            var data = canvas.toDataURL();
            document.body.removeChild(canvas);
            return data;
        }
        else {
            return "";
        }
    };
    return ImageUtil;
}());
exports.ImageUtil = ImageUtil;
//# sourceMappingURL=image-helper.js.map